import {View} from 'backbone';
import template from 'common-views/advanced-user-signup-modal.ejs';
import constants from 'Constants.js';
import RestService from 'RestService.js';
import NotificationService from 'NotificationService.js';
import util from 'util/Util.js';
import $ from 'jquery';

class AdvancedUserSignupModalView extends View {
    initialize(opts) {
        super.initialize(opts);
        $('body').append(this.$el);
    }

    loadConnectionsToView() {
        RestService.getConnections(
            constants.SETTINGS_CONNECTIONS_FORM_ID,
            constants.SETTINGS_CONNECTIONS_TYPE,
            constants.SETTINGS_CONNECTIONS_PURPOSE).then((connectionData)=> {
            this.renderConnectionOptions(connectionData);
            this.canSave();
        }).catch((err)=> {
            console.log("This is the error", err);
            NotificationService.error("There was an error while loading connections:" + err);
        });
    }

    renderConnectionOptions(connectionData){

        let connectionSelect = $('select[name="UserSignUpConnectionId"]');
        let actionSelect = $('select[name="UserSignUpActionId"]');
        connectionSelect.empty();
        actionSelect.empty();
        $('.paramSend').empty().prop('disabled',true);
        $('.paramReturn').empty().prop('disabled',true);
        $('.paramCustom').empty().prop('disabled',true);
        $('.extraParams').prop('disabled',true);
        if ($.isEmptyObject(connectionData)) {
            util.appendOptionToSelect(connectionSelect, 'none', constants.EMPTY_CONNECTIONS_OPTION, true);
        }
        else {
            util.appendOptionToSelect(connectionSelect, 'none', constants.CONNECTIONS_DEFAULT_OPTION, true);
            // If a previous search ocurred, dont append the default option.
            for (let connection of connectionData) {
                util.appendOptionToSelect(connectionSelect, connection['@ConnectionId'], connection['@Name'], false, connection['@Type']);
            }
        }
    }

    renderActionOptions(actionData){
        let actionSelect = $('select[name="UserSignUpActionId"]');
        actionSelect.empty();
        actionSelect.prop('disabled', false);
        $('.paramSend').empty().prop('disabled',true);
        $('.paramReturn').empty().prop('disabled',true);
        $('.paramCustom').empty().prop('disabled',true);
        $('.extraParams').prop('disabled',true);

        if ($.isEmptyObject(actionData)) {
            util.appendOptionToSelect(actionSelect, 'none', constants.EMPTY_ACTIONS_OPTION, true);
        }
        else {
            // If there was already an action saved into the model, must be selected on render.
            for (let action of actionData) {
                util.appendOptionToSelect(actionSelect, action['@ActionId'], action['@Name']);
            }
            util.prependOptionToSelect(actionSelect, 'none', constants.ACTIONS_DEFAULT_OPTION, true);
        }
    }

    renderParameterOptions(parameterData){
        $('#dialog').find('.disableLookup').prop('disabled', false);
        $('.paramSend').empty();
        $('.paramReturn').empty();
        $('.paramCustom').empty();

        console.log("These are the parameters", parameterData);
        let sendList = $('.paramSend');
        let returnList = $('.paramReturn');
        if(this.model.get('IncludeCustomIdInUserSignUp') === 'True'){
            returnList.push($('.paramCustom')[0]);
            console.log('Return List :',returnList);
        }

        // If there is no parameters on Send.
        if(parameterData.sendParameters[0] === undefined){
            for (let sendSelect of sendList) {
                util.appendOptionToSelect($(sendSelect), 'none', constants.EMPTY_PARAMETERS_OPTION, true);
            }
        }

        // Else Iterate them and place them as options.
        else {
            for (let sendParameter of parameterData.sendParameters) {
                for (let sendSelect of sendList) {
                    util.appendOptionToSelect($(sendSelect), sendParameter['_id'], sendParameter['_name']);
                }
            }
            util.prependOptionToSelect(sendList, 'none', constants.PARAMETERS_DEFAULT_OPTION, true);
        }
        // If there is no parameters on Return.
        if(parameterData.returnParameters[0] === undefined){

            for (let returnSelect of returnList) {
                util.appendOptionToSelect($(returnSelect), 'none', constants.EMPTY_PARAMETERS_OPTION, true);
            }
        }
        // Else Iterate them and place them as options.
        else {
            // Add data for Custom Id If Required
            console.log('This is the value of Include Custom',this.model.get('IncludeCustomIdInUserSignUp'));
            for (let returnParameter of parameterData.returnParameters) {
                for (let returnSelect of returnList) {
                    util.appendOptionToSelect($(returnSelect), returnParameter['_id'], returnParameter['_name']);
                }
            }
            console.log("Returned List",returnList);
            util.prependOptionToSelect(returnList, 'none', constants.PARAMETERS_DEFAULT_OPTION, true);
        }
    }

    loadActionsToView(ev) {
        console.log("Im on connections");
        let connectionId = ev.currentTarget.value;
        this.model.set(ev.currentTarget.name,ev.currentTarget.value,{silent:true});
        RestService.getActionsByConnectionId(
            connectionId,
            constants.SETTINGS_CONNECTIONS_FORM_ID,
            constants.SETTINGS_CONNECTIONS_PURPOSE).then((actions)=> {
            this.renderActionOptions(actions);
            this.model.set('UserSignUpActionId','none',{silent:true});
            this.model.set('UserSignUpLookupCaption','',{silent:true});
            $("input[name='UserSignUpLookupCaption']").val('');
            this.canSave();
        }).catch((err)=> {
            NotificationService.error("There was an error loading actions:" + err);
        });

    }

    loadParametersToView(ev) {
        console.log("Im on actions");
        let connectionId = $('select[name="UserSignUpConnectionId"]').val();
        let actionId = ev.currentTarget.value;
        this.model.set(ev.currentTarget.name,ev.currentTarget.value,{silent:true});
        RestService.getParametersByActionIdAndConnectionId(
            actionId,
            connectionId,
            constants.SETTINGS_CONNECTIONS_FORM_ID,
            constants.SETTINGS_PARAMETERS_PURPOSE).then((parameterData)=> {

            this.renderParameterOptions(parameterData);
            this.model.set('UserSignUpFirstNameParameterId','none',{silent:true});
            this.model.set('UserSignUpLastNameParameterId','none',{silent:true});
            this.model.set('UserSignUpEmailParameterId','none',{silent:true});
            this.model.set('UserSignUpLookupParameterId','none',{silent:true});
            this.model.set('UserSignUpLookupCaption','',{silent:true});
            $("input[name='UserSignUpLookupCaption']").val('');
            this.canSave();
        }).catch((err)=> {
            console.log("There was an error loading parameters:",err);
            NotificationService.error("There was an error loading parameters:" + err);
        });
    }

    useLookup(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.checked === true ? 'True':'False';
        this.model.set(propName, propVal);
        console.log("PropVal", propVal);
        this.validateDisabledFields();

    }

    validateDisabledFields(){
        let propVal=this.model.get('UserSignUpUseLookup');
        if (propVal === 'True') {
            $('#dialog').find('select[name="UserSignUpConnectionId"]').prop('disabled', false);
            if (this.model.get('UserSignUpActionId')) {
                $('#dialog').find('.disableLookup').prop('disabled', false);
            }
        }
        else {
            $('#dialog').find('.disableLookup').prop('disabled', true);
        }
        this.canSave();
    }

    saveParameters(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        this.model.set(propName, propVal,{silent:true});
        console.log("User SignUpModel", this.model);
        this.canSave();
    }

    render() {
        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
            this.delegateEvents();

            $(constants.DIALOG_ID).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: 'auto',
                width: 600,
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'Ok',
                        'class': 'btn-select-item',
                        disabled: true,
                        click: () => {
                            resolve(this.model.attributes);
                            this.closeModal();
                        }
                    },
                    {
                        'text': 'Cancel',
                        click: () => {
                            resolve();
                            this.closeModal();
                        }
                    }
                ],
                open: () => {
                    this.initialUIStartup();
                    this.bindEvents();
                },
                close: () => {
                    this.unbindEvents();
                }
            });

            $('div[role="dialog"]').draggable(constants.DEFAULT_DRAGGABLE_OPTIONS);
        });
    }

    initialUIStartup() {
        if(this.model.get('UserSignUpConnectionId')){
            this.loadExistingData();
        }
        else{
            this.enableControls();
            this.loadConnectionsToView();
        }
    }

    validateDropdownLoad(elements,modelAttribute){
        this.validateDisabledFields();
        if(elements.length === 0){ $("input[name='UserSignUpLookupCaption']").val(''); return false; }
        else if(!this.isAlreadySaved(modelAttribute)){ $("input[name='UserSignUpLookupCaption']").val('');return false;}
        return true;
    }
//
    loadExistingData(){
        console.log('Current Model',this.model);
        RestService.getConnections(
            constants.SETTINGS_CONNECTIONS_FORM_ID,
            constants.SETTINGS_CONNECTIONS_TYPE,
            constants.SETTINGS_CONNECTIONS_PURPOSE).then((connections)=>{
            this.renderConnectionOptions(connections);
            // If connections are empty don't load the rest of the dropdowns and clean the Lookup Caption.
            if(!this.validateDropdownLoad(connections,'UserSignUpConnectionId')){return;}

            RestService.getActionsByConnectionId(
                this.model.get('UserSignUpConnectionId'),
                constants.SETTINGS_CONNECTIONS_FORM_ID,
                constants.SETTINGS_CONNECTIONS_PURPOSE).then((actions)=>{
                this.renderActionOptions(actions);

                // If actions are empty don't load the rest of the dropdowns and clean the Lookup Caption
                if(!this.validateDropdownLoad(connections,'UserSignUpActionId')){return;}
                RestService.getParametersByActionIdAndConnectionId(
                    this.model.get('UserSignUpActionId'),
                    this.model.get('UserSignUpConnectionId'),
                    constants.SETTINGS_CONNECTIONS_FORM_ID,
                    constants.SETTINGS_PARAMETERS_PURPOSE).then((parameters)=>{
                    this.renderParameterOptions(parameters);
                    this.chooseExistingOptions();
                    this.validateDisabledFields();
                }).catch((err)=>{
                    console.log("Error loading parameters " ,err);
                    NotificationService.error("Error loading parameters " + err);
                });
            }).catch((err)=>{
                console.log("Error loading actions " , err);
                NotificationService.error("Error loading actions " + err);
            });
        }).catch((err)=>{
            console.log("Error loading connections " , err);
            NotificationService.error("Error loading connections " + err);
        });
    }

    canSave() {
        let currentModel = this.model.attributes;
        console.log("Can Save Model",currentModel);
        if(currentModel.UserSignUpUseLookup === 'False'){
            $('.btn-select-item').prop('disabled', false).removeClass('ui-button-disabled').removeClass('ui-state-disabled');
            return;
        }
        if (currentModel.IncludeCustomIdInUserSignUp === 'True') {

            if (
            (currentModel.UserSignUpLookupParameterId && currentModel.UserSignUpLookupParameterId !== 'none') &&
            (currentModel.UserSignUpFirstNameParameterId && currentModel.UserSignUpFirstNameParameterId !== 'none') &&
            (currentModel.UserSignUpLastNameParameterId && currentModel.UserSignUpLastNameParameterId !== 'none') &&
            (currentModel.UserSignUpEmailParameterId && currentModel.UserSignUpEmailParameterId !== 'none') &&
            (currentModel.UserSignUpLookupCaption && currentModel.UserSignUpLookupCaption !== '') &&
            (currentModel.UserSignUpCustomIdParameterId && currentModel.UserSignUpCustomIdParameterId !== 'none')) {
                $('.btn-select-item').prop('disabled', false).removeClass('ui-button-disabled').removeClass('ui-state-disabled');
            }
            else {
                $('.btn-select-item').prop('disabled', true).addClass('ui-button-disabled').addClass('ui-state-disabled');
            }
        }
        else {
            if (
            (currentModel.UserSignUpLookupParameterId && currentModel.UserSignUpLookupParameterId !== 'none') &&
            (currentModel.UserSignUpFirstNameParameterId && currentModel.UserSignUpFirstNameParameterId !== 'none') &&
            (currentModel.UserSignUpLastNameParameterId && currentModel.UserSignUpLastNameParameterId !== 'none') &&
            (currentModel.UserSignUpEmailParameterId && currentModel.UserSignUpEmailParameterId !== 'none') &&
            (currentModel.UserSignUpLookupCaption && currentModel.UserSignUpLookupCaption !== '')) {
                $('.btn-select-item').prop('disabled', false).removeClass('ui-button-disabled').removeClass('ui-state-disabled');
            }
            else {
                $('.btn-select-item').prop('disabled', true).addClass('ui-button-disabled').addClass('ui-state-disabled');
            }
        }
    }

    chooseExistingOptions(){
        $(`select[name="UserSignUpConnectionId"] option[value="${this.model.get('UserSignUpConnectionId')}"]`).prop('selected',true);
        $(`select[name="UserSignUpActionId"] option[value="${this.model.get('UserSignUpActionId')}"]`).prop('selected',true);
        $(`select[name="UserSignUpLookupParameterId"] option[value="${this.model.get('UserSignUpLookupParameterId')}"]`).prop('selected',true);
        $(`select[name="UserSignUpFirstNameParameterId"] option[value="${this.model.get('UserSignUpFirstNameParameterId')}"]`).prop('selected',true);
        $(`select[name="UserSignUpLastNameParameterId"] option[value="${this.model.get('UserSignUpLastNameParameterId')}"]`).prop('selected',true);
        $(`select[name="UserSignUpEmailParameterId"] option[value="${this.model.get('UserSignUpEmailParameterId')}"]`).prop('selected',true);
        if(this.model.get("IncludeCustomIdInUserSignUp") === 'True'){
            $(`select[name="UserSignUpCustomIdParameterId"] option[value="${this.model.get('UserSignUpCustomIdParameterId')}"]`).prop('selected',true);
        }
    }

    isAlreadySaved(modelProperty){
        let currentModelProperty=this.model.get(modelProperty);
        let currentModelPropertyOptions=$(`select[name="${modelProperty}"] option`).toArray();
        console.log('Model Options',currentModelPropertyOptions);
        let result = currentModelPropertyOptions.filter((option)=>{
                return currentModelProperty!== 'none' && option.value === currentModelProperty;
            }).length > 0;
        console.log("Model result",result);
        return result;
    }

    enableControls(){
        console.log("This is the value of Use Lookup", $('#dialog').find('input[name="UserSignUpUseLookup"]').prop('checked'));
        if ($('#dialog').find('input[name="UserSignUpUseLookup"]').prop('checked')) {
            $('.disableLookup').prop('disabled', false);
        }
        else {
            $('.disableLookup').prop('disabled', true);
        }
    }

    allowManualEditing(ev){
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.checked; //=== true ? 'True':'False';
        //
        this.model.set(propName, propVal,{silent:true});
        console.log("User SignUpModel", this.model);
        this.canSave();
    }

    bindEvents() {
        // Binding Dropdown Events
        let dialog = $(constants.DIALOG_ID);
        dialog.css('overflow', 'hidden');
        dialog.find('input[name="UserSignUpUseLookup"]').change(e => this.useLookup(e));
        dialog.find('select[name="UserSignUpConnectionId"]').change(e => this.loadActionsToView(e));
        dialog.find('select[name="UserSignUpActionId"]').change(e => this.loadParametersToView(e));
        dialog.find('.paramSend').change(e=>this.saveParameters(e));
        dialog.find('.paramReturn').change(e=>this.saveParameters(e));
        dialog.find('.paramCustom').change(e=>this.saveParameters(e));
        dialog.find('select[name="UserSignUpCustomIdParameterId"]').change(e=>this.saveParameters(e));
        dialog.find('input[name="UserSignUpLookupCaption"]').change(e=>this.saveParameters(e));
        dialog.find('input[name="UserSignUpAllowManualEditing"]').change(e=>this.allowManualEditing(e));
    }

    unbindEvents() {
        // UnBinding Dropdown Events
        let dialog = $(constants.DIALOG_ID);
        dialog.find('input[name="UserSignUpUseLookup"]').unbind();
        dialog.find('select[name="UserSignUpConnectionId"]').unbind();
        dialog.find('select[name="UserSignUpActionId"]').unbind();
        dialog.find('.paramSend').unbind();
        dialog.find('.paramReturn').unbind();
        dialog.find('.paramCustom').unbind();
        dialog.find('select[name="UserSignUpCustomIdParameterId"]').unbind();
        dialog.find('input[name="UserSignUpLookupCaption"]').unbind();
        dialog.find('input[name="UserSignUpAllowManualEditing"]').unbind();
    }

    closeModal() {
        $(constants.DIALOG_ID).dialog("destroy");
        $(constants.DIALOG_ID).remove();
    }
}

export default AdvancedUserSignupModalView;